/**
 * The variables a notification message template can read (TO-140
 * offer-notification-dispatch REQ-202), in display order. A copy of
 * `MESSAGE_TEMPLATE_VARIABLES` in `@today/template-engine`
 * (`packages/core/template-engine/src/message/message-template.ts`): that package is
 * server-side (liquidjs) and not a frontend dependency, so keep the two in step.
 */
export const MESSAGE_TEMPLATE_VARIABLES: readonly string[] = [
	'customer.full_name',
	'offer.short_url',
	'offer.product_names',
	'offer.expires_at',
	'offer.locale',
	'manager.full_name',
	'manager.branch_name',
]

/** The longest template body or custom message the API accepts. */
export const NOTIFICATION_BODY_MAX = 2000
